/* dba-lazy-gallery: imágenes marcadas .dba-defer no traen src hasta que hacen falta. */
(function(){
  function restore(img){
    if(img.dataset.srcset){img.srcset=img.dataset.srcset;delete img.dataset.srcset;}
    if(img.dataset.src){img.src=img.dataset.src;delete img.dataset.src;}
    img.classList.remove('dba-defer');
  }
  function restoreIn(root){
    var l=(root||document).querySelectorAll('img.dba-defer');
    for(var i=0;i<l.length;i++) restore(l[i]);
  }
  function init(){
    var imgs=document.querySelectorAll('img.dba-defer');
    if(!imgs.length) return;
    if(!('IntersectionObserver' in window)){restoreIn(document);return;}
    /* margen sólo vertical: si fuese horizontal, el slide 2 del carrusel se bajaría siempre */
    var io=new IntersectionObserver(function(es){
      for(var i=0;i<es.length;i++) if(es[i].isIntersecting){restore(es[i].target);io.unobserve(es[i].target);}
    },{rootMargin:'250px 0px 250px 0px',threshold:0.25});
    for(var i=0;i<imgs.length;i++) io.observe(imgs[i]);
    /* al tocar la galería se traen TODOS sus slides, no las imágenes del resto de la página */
    var g=document.querySelector('media-gallery')||document.querySelector('.product__media-wrapper')||document.querySelector('.product__media-list');
    if(g){['pointerdown','touchstart','keydown'].forEach(function(ev){
      g.addEventListener(ev,function(){restoreIn(g);},{once:true,passive:true});});}
    document.addEventListener('variant:change',function(){restoreIn(g||document);},{once:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();